module.exports = __webpack_public_path__ + "img/AF986F_CDB489_9C7C5B_7E6C4D-256px.7d096006.png";